export const KINDS = {
  DEFAULT: 'Default',
  PILL: 'Pill',
} as const

export const COLORS = {
  PRIMARY: 'Primary',
} as const

export const SIZES = {
  MEDIUM: 'Medium',
  LARGE: 'Large',
} as const

type KindsType = typeof KINDS
type KindsKeys = keyof KindsType
export type TabKinds = KindsType[KindsKeys]

type ColorType = typeof COLORS
type ColorKeys = keyof ColorType
export type ColorKinds = ColorType[ColorKeys]

type SizesType = typeof SIZES
type SizesKeys = keyof SizesType
export type SizesKinds = SizesType[SizesKeys]

export const TABS_DISPLAY_NAME = 'Tabs'
export const TAB_DISPLAY_NAME = 'Tab'
